module.exports = __webpack_public_path__ + "static/eye-opened-main-page-fa3226bb8381a7552f846acb12941442.svg";